import TableList from './TableList';
import type { TableListColumnType } from './TableList.types';

export type { TableListColumnType };
export default TableList;
